'use client';

import { NoDataMessage } from '@/components/molecules/NoDataMessage';
import { MatchLineupHeader } from '@/components/molecules/ScoreCards/MatchLineupHeader';
import { MatchupLineUpHeaderSkeleton } from '@/components/pages/skeletons/MatchupLineUpHeaderSkeleton';
import { useMatchesQuery } from '@/hooks/matches/useMatchesQuery';

interface TieBreakerTeamHeaderProps {
	matchupId: string;
}

export const TieBreakerTeamHeader = ({ matchupId }: TieBreakerTeamHeaderProps) => {
	const { data: matchesResponse, isLoading } = useMatchesQuery(matchupId);

	if (isLoading) return <MatchupLineUpHeaderSkeleton />;

	if (!matchesResponse?.data) {
		return <NoDataMessage title="No rally here!" description="There's no data to show yet. Stretch it out and check back later!" />;
	}

	return <MatchLineupHeader matchupData={matchesResponse.data} backLinkUrl={`../${matchupId}`} previousPageTitle="Back" isTieBreaker />;
};
